import { cancel } from 'helpers/dom-helper';
import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['form'];
  static values = {
    append: { type: Boolean, default: true },
    portalId: { type: String, default: 'portal' },
  };

  initialize() {
    this.cachedElement = this.element;

    this.onShow = this.onShow.bind(this);
    this.onShown = this.onShown.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onHidden = this.onHidden.bind(this);

    $(this.element).on('show.bs.modal', this.onShow);
    $(this.element).on('shown.bs.modal', this.onShown);
    $(this.element).on('hide.bs.modal', this.onHide);
    $(this.element).on('hidden.bs.modal', this.onHidden);

    this.element.addEventListener('keydown', onKeydown); // Nested modals will close all parent modals. So we need to manually listen for `keydown` event.
  }

  disconnect() {
    $(this.element).off('show.bs.modal', this.onShow);
    $(this.element).off('shown.bs.modal', this.onShown);
    $(this.element).off('hidden.bs.modal', this.onHidden);
    $(this.element).off('hidden.bs.modal', this.onHidden);

    this.cachedElement = undefined;
    this.element.removeEventListener('keydown', onKeydown);
  }

  hide() {
    $(this.element).modal('hide');
  }

  // Private
  onShow() {
    // Append directly to the portal to avoid overflow issues. Unfortunately, as of now, bootstrap doesn't handle this
    // natively.
    if (this.appendValue && this.element.parentNode.nodeName !== 'BODY') {
      this.cachedElement.remove();
      this.portal.append(this.element);
    }

    this.dispatch('show', { bubbles: true });
  }

  onShown() {
    this.dispatch('shown', { bubbles: true });
  }

  onHide(event) {
    if (event.target === this.element && this.hasFormTarget) {
      this.formTargets.forEach((form) => form.reset());
    }

    this.dispatch('hide', { bubbles: true });
  }

  onHidden(event) {
    // Bootstrap doesn't support nested modals, yet. When a modal closes, bootstrap removes the `modal-open` class
    // from the `body` tag. In case of nested modals, we only want to remove if the modal is the last in the stack.
    if (event.target === this.element && this.isNested) {
      document.body.classList.add('modal-open');
    }

    this.dispatch('hidden', { bubbles: true });
  }

  get portal() {
    return document.getElementById(this.portalIdValue) || document.body;
  }

  get isNested() {
    return this.element.classList.contains('modal-nested');
  }
}

function onKeydown(event) {
  if (event.key === 'Escape') {
    cancel(event);
  }
}
